module.exports = __webpack_public_path__ + "img/code.60613ce1.png";